import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: null,
  data: {},
};

export default function reducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case actionTypes.DIVISIONS_LIST_LOADING: {
      return {
        ...state,
        loading: true,
      };
    }
    case actionTypes.DIVISIONS_LIST_SUCCESS: {
      return {
        loading: false,
        data: { ...payload },
      };
    }
    case actionTypes.DIVISIONS_LIST_CLEAR: {
      return {
        loading: false,
        data: {},
      };
    }
    case actionTypes.DIVISIONS_LIST_ERROR: {
      return {
        loading: false,
        data: {},
        error: payload,
      };
    }

    default:
      return state;
  }
}
